import React, { Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import ArtistsListSection from '../artists-list-section.js/artists-list-section';


@inject('genreStore', 'artistStore', 'playlistStore')
@observer
export default class Genre
extends React.Component {
	render () {
		const { genreStore, artistStore, playlistStore } = this.props;

		if (genreStore.isLoading || artistStore.isLoading || playlistStore.isLoading) {

			return (<h1>Loading...</h1>);
		}

		const { match: { params: { id } } } = this.props;
		const genre = genreStore.getItemByID(id);

		const genrePlaylists = playlistStore.items.filter(p=>p.showOnFrontPage === false && p.genre === genre._id);
		console.log(genrePlaylists);
		
		const titleClassList = {
			'fontSize': '3.2em',
			'color': '#282828',
			'letterSpacing': '0.05em'
		}

		return (
			<Fragment>
				<div className="grid-x">
					<div className="cell small-12">
						<div className="section-title" style={titleClassList}>{ genre.label }</div>
					</div>
				</div>

				<div className="grid-x grid-padding-x margin-top-3">
					{ this.renderArtistsList(genrePlaylists) }
				</div>
			</Fragment>
		);
	}

	renderArtistsList (targetPlaylists) {
		if (targetPlaylists.length === 0) {

			return (
				<div className="cell small-12">
					<p className="primary-font">Check back soon for artists from this genre.</p>
				</div>
			);
		}

		return (
			<div className='padding-left-1'>
				{
					targetPlaylists.map((playlist, idx) => {
						return (
							<ArtistsListSection
								sectionLabel={playlist.title}
								artists={playlist.songs}
								key={`${playlist.title}-${idx}`}
							/>
						)
					})
				}
			</div>
		);
	}
}
